import OtherRoomsSection from './OtherRoomsSection';

export default OtherRoomsSection;
